import { render, staticRenderFns } from "./AdminUserList.vue?vue&type=template&id=6567ccd0&"
import script from "./AdminUserList.vue?vue&type=script&lang=js&"
export * from "./AdminUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports